import styled from "styled-components";
import { layout } from "styled-system";

export const Wrapper = styled.div`
  background: ${(props) => props.theme.colors.coral};
  ${layout};
`;
